module.exports = __webpack_public_path__ + "img/danger-sign.8258e7e8.svg";